













































































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { uniqBy } from "lodash";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CustomTable from "@/components/form/CustomTable.vue";
import AgentPaymentTableItem from "@/components/reports/AgentPaymentTableItem.vue";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { Payment as IPayment } from "@/api-v2/agent/models/payment";
import { AgentPaymentSort, SortFields } from "@/plugins/sort-fields";

@Component({
  components: {
    CustomButton,
    CustomDatepicker,
    AgentPaymentTableItem,
    CustomTable,
    CBlock
  }
})
export default class AgentPaymentTable extends Vue {
  @Prop({ default: false }) isLoading?: boolean;
  @Prop({ default: () => [] }) payments!: IPayment[];
  @Prop({ default: 0 }) count?: number;
  sorted: SortFields<AgentPaymentSort> = new SortFields(
    AgentPaymentSort.paymentAt
  );
  selected: IPayment[] = [];
  indeterminate: boolean = false;
  checkedAll: boolean = false;
  agentPaymentDate: Date = new Date();

  get summaryAmount() {
    return this.selected?.length
      ? this.selected?.reduce((acc, curr) => acc + curr.amount, 0)
      : this.payments?.reduce((acc, curr) => acc + curr.amount, 0);
  }

  get summaryAgent() {
    return this.selected?.length
      ? this.selected?.reduce((acc, curr) => acc + curr.agentAmount, 0)
      : this.payments?.reduce((acc, curr) => acc + curr.agentAmount, 0);
  }

  get isShowAddMoreButton() {
    return this.payments?.length < (this.count ?? 0);
  }

  get sortStatus() {
    return AgentPaymentSort;
  }

  acceptSort(sort: AgentPaymentSort) {
    this.sorted.changeSort(sort);
    this.$emit("changeSort", this.sorted.order);
  }

  changeDateAgentPaymentAt(value: {
    paymentId: string;
    agentPaymentAt?: Date;
  }) {
    this.selected = this.selected?.filter(el => el.id !== value.paymentId);
    this.$emit("changeDateAgentPaymentAt", value);
  }

  showMore() {
    this.$emit("showMore");
  }

  isSelectedPayment(paymentId: string) {
    return this.selected?.some(el => el.id === paymentId);
  }

  toggleAll(checked: boolean) {
    this.selected = checked
      ? uniqBy(
          [
            ...this.selected,
            ...this.payments?.filter(el => !el.agentPaymentAt)
          ],
          "id"
        )
      : [];
  }

  addAgentPaymentDate() {
    const value: { payments: IPayment[]; date: Date } = {
      payments: this.selected,
      date: this.agentPaymentDate
    };
    this.$emit("updatePaymentDate", value);
    this.selected = [];
  }

  selectPayment(payment: IPayment) {
    this.selected = uniqBy([...this.selected, payment], "id");
  }

  unselectPayment(payment: IPayment) {
    this.selected = this.selected?.filter(el => el.id !== payment.id);
  }

  @Watch("selected")
  checkSelected(newValue: any) {
    if (newValue.length === 0) {
      this.indeterminate = false;
      this.checkedAll = false;
    } else if (newValue.length === this.payments?.length) {
      this.indeterminate = false;
      this.checkedAll = true;
    } else {
      this.indeterminate = true;
      this.checkedAll = false;
    }
    this.$emit("input", this.selected);
  }
}
